import React, { useState, useRef, useEffect } from "react";
import { Loading } from "seed/helpers";
import { getMention } from "components/util/schema_form/fields/rich_text/Editor.lib";
import { assignIdxNodes } from "components/studio/Controller.lib.index"
import * as parser from "components/studio/Controller.lib.parser";
import * as graph from "components/util/schema_form/util/graph";
import * as lib from "components/util/schema_form/fields/rich_text/RichText.lib";

import View from "components/util/schema_form/fields/rich_text/RichText.view";

function RichText({
  name,
  label,
  value = "",
  values,
  required,
  dataReqs,
  rows = 5,
  nodeId,
  parentId,
  caption,
  helpMessage,
  placeholder,
  singleLine,
  showStyles,
  variableOptions,
  flowId,
  setFieldValue
}) {

  const [isVariableModalOpen, setIsVariableModalOpen] = useState(false);
  const [commandEditor, setCommandEditor] = useState(() => { });
  const [content, setContent] = useState(null)
  const editorRef = useRef(null);

  useEffect(() => {
    if (value == null || (typeof value === 'object' && Object.keys(value).length === 0))
      setFieldValue(name, "")
  }, [flowId, nodeId]);

  if (dataReqs.nodes.loading || dataReqs.edges.loading || dataReqs.collections.loading || dataReqs.dataTypes.loading) 
      return <Loading size={27} />;
    if (dataReqs.nodes.error || dataReqs.edges.error || dataReqs.collections.error || dataReqs.dataTypes.error) 
      return "Error";

  const nodes = [];
  const tempNodes = [...dataReqs.nodes.data.flowNodes];
  const tempEdges = [...dataReqs.edges.data.flowEdges];
  const collections = dataReqs.collections.data.collections;
  const datatypes = dataReqs.dataTypes.data.appDatatypes;

  // Assign IDX to nodes
  const parsedNodes = parser.parseNodesGraphqlToUi(tempNodes);
  const parsedEdges = parser.parseEdgesGraphqlToUi(tempEdges);
  const nodesWithIdx = assignIdxNodes(parsedNodes, parsedEdges);

  // Filter only nodes that are ancestors of the current node or the current parent
  const filteredNodes = graph.getAncerstorNodes(nodesWithIdx, parsedEdges, nodeId, parentId)

  for (const node of filteredNodes) {
    let currentNode = { ...tempNodes.find(nd => nd.id == node.data.remoteId) };
    if (currentNode && currentNode.action.outputStructure.length > 0 && currentNode.id != nodeId) {
      currentNode.idx = node.data.idx
      nodes.push(currentNode)
    }
  }

  // Init content
  if (content == null && value != null) {
    if (!showStyles) setContent(lib.plainToHtmlContent(value, nodes, collections, datatypes))
    else setContent(value)
  }


  const onChangeValue = (htmlContent) => {
    const plainContent = lib.htmlToPlainContent(htmlContent)
    const newValue = showStyles ? (plainContent != "" ? htmlContent : "") : plainContent
    setContent(htmlContent)
    setFieldValue(name, newValue)
  }

  const onClickAddReference = (command) => {
    setCommandEditor(() => command);
    setIsVariableModalOpen(true);
  }

  const onCloseAddReference = () =>
    setIsVariableModalOpen(false)

  const onVariableSelected = (value) => {
    const mention = getMention(value, nodes, collections, datatypes);
    if (mention) {
      commandEditor(mention)
    }
    setIsVariableModalOpen(false)
  }

  return (
    <View
      editorRef={editorRef}
      content={content}
      nodes={nodes}
      nodeId={nodeId}
      collections={collections}
      datatypes={datatypes}
      name={name}
      label={label}
      required={required}
      caption={caption}
      helpMessage={helpMessage}
      placeholder={placeholder}
      singleLine={singleLine}
      rows={rows}
      showStyles={showStyles}
      variableOptions={variableOptions}
      values={values}
      isVariableModalOpen={isVariableModalOpen}
      setFieldValue={setFieldValue}
      onChangeValue={onChangeValue}
      onVariableSelected={onVariableSelected}
      onClickAddReference={onClickAddReference}
      onCloseAddReference={onCloseAddReference}
    />
  );
}

export default RichText;